/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".toggle-link[_ngcontent-%COMP%]{display:-ms-inline-flexbox;display:inline-flex}"];
export { styles as styles };
